import { createTheme } from "@mui/material/styles";

// A custom theme for this app
const theme = createTheme({
  typography: {
    fontFamily: ["Jost", '"Helvetica Neue"', "Arial", "sans-serif"].join(","),
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        input: {
          background: "#fff",
          "&:-webkit-autofill": {
            background: "#fff !important",
            WebkitBoxShadow: "0 0 0 1000px #fff inset",
            WebkitTextFillColor: "#000",
          },
        },
      },
    },
  },
});

export default theme;
